import React from "react";
import CustomBadge from "../../../common/CustomBadge";
import { withStyles } from "@material-ui/core/styles";
const styles = () => ({
  divStyle: {
    display: "flex",
    justifyContent: "center",
  },
  superscriptText: {
    fontSize: 8,
  },
});

const BadgeList = ({ classes, pieces, hu, weight, cube }) => (
  <div className={classes.divStyle}>
    <CustomBadge value={pieces ? pieces : "-"} labelText="Pieces" />
    <CustomBadge
      value={cube ? cube : "-"}
      labelText={
        <span>
          FT<sup className={classes.superscriptText}>3</sup>
        </span>
      }
    />
    <CustomBadge value={hu ? hu : "-"} labelText="HU" />
    <CustomBadge value={weight ? weight : "-"} labelText="LBS" />
  </div>
);
export default withStyles(styles)(BadgeList);
